<script>
  export default {
    name: 'DiseaseCompare',
    props: {
      names: {
        type: Array,
        default() {
          return []
        }
      },
      visible: {
        type: Boolean,
        default: false
      },
      template: {
        type: Array,
        default() {
          return []
        }
      }
    },
    data() {
      return {
      }
    },
    watch: {
    },
    created() {
    },
    methods: {
      handleCompare(row) {
        this.$emit('disease-compare', row)
      }
    }
  }
</script>

<template>
  <div
    v-if="template.length > 0"
    class="dis-compare-wrapper"
  >
    <div
      v-for="item in template"
      class="dis-compare-item"
    >
      <div class="compare-table after-bdr">
        <table>
          <thead>
            <tr>
              <td>
                <p v-if="names[0]">
                  {{ names[0].name }}
                </p>
                <p v-if="item.category">
                  {{ item.category.name }}
                </p>
              </td>
              <td>
                <p v-if="names[1]">
                  {{ names[1].name }}
                </p>
                <p v-if="item.comparedCategory">
                  {{ item.comparedCategory.name }}
                </p>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <template v-if="item.category">
                  <p :class="{'max': item.comparedCategory && (item.category.diseaseNum > item.comparedCategory.diseaseNum) }">
                    {{ item.category.diseaseNum }}种
                  </p>
                  <p v-if="item.category.group" key="group">
                    分{{ item.category.group }}组
                  </p>
                  <p v-else key="group">
                    无分组
                  </p>
                  <p :class="{'max': item.comparedCategory && (item.category.payoutNum > item.comparedCategory.payoutNum) }">
                    赔付{{ item.category.payoutNum }}次
                  </p>
                  <p>{{ item.category.payoutPercentage }}</p>
                </template>
                <template v-else>
                  <p class="empty-center">
                    —
                  </p>
                </template>
                <i class="compare">vs</i>
              </td>
              <td>
                <template v-if="item.comparedCategory">
                  <p :class="{'max': item.category && (item.comparedCategory.diseaseNum > item.category.diseaseNum) }">
                    {{ item.comparedCategory.diseaseNum }}种
                  </p>
                  <p v-if="item.comparedCategory.group" key="group">
                    分{{ item.comparedCategory.group }}组
                  </p>
                  <p v-else key="group">
                    无分组
                  </p>
                  <p :class="{'max': item.category && (item.comparedCategory.payoutNum > item.category.payoutNum) }">
                    赔付{{ item.comparedCategory.payoutNum }}次
                  </p>
                  <p>{{ item.comparedCategory.payoutPercentage }}</p>
                </template>
                <template v-else>
                  <p class="empty-center">
                    —
                  </p>
                </template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <ul
        v-if="visible"
        class="compare-list after-bdr"
      >
        <li class="thead">
          <div class="cell">
            <template v-if="names[0]">
              {{ names[0].name }}
            </template>
            <template v-else>
              —
            </template>
          </div>
          <div class="cell">
            <template v-if="names[1]">
              {{ names[1].name }}
            </template>
            <template v-else>
              —
            </template>
          </div>
          <div class="cell">
            相似度
          </div>
        </li>
        <li
          v-for="(row, index) in item.diseaseList"
          :key="index"
          @click="handleCompare(row)"
        >
          <div class="cell">
            <p v-if="row.disease">
              {{ row.disease.number + '.' + row.disease.name }}
            </p>
            <p v-else>
              —
            </p>
          </div>
          <div class="cell">
            <p v-if="row.comparedDisease">
              {{ row.comparedDisease.number + '.' + row.comparedDisease.name }}
            </p>
            <p v-else>
              —
            </p>
          </div>
          <div class="cell">
            <p>{{ row.contrast }}</p>
            <i class="iconfont icon-arrows_right" />
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<style scoped>
  @import 'variable';

  .dis-compare-item {
    margin-bottom: 15px;
    background-color: #fff;
    color: #666;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .compare-table {
    background-color: #f8f8f8;
    margin-bottom: 5px;
    table {
      width: 100%;
      text-align: center;
      font-size: 13px;
      table-layout: fixed;
      word-break: break-all;
      thead {
        td {
          width: 50%;
          padding: 9px 21px;
          color: #fff;
          p {
            width: 100%;
            margin-bottom: 3px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            &:first-child {
              font-weight: 600;
            }
          }
          &:first-child {
            background-color: #70acf6;
          }
          &:last-child {
            background-color: #ff9900;
          }
        }
      }
      tbody {
        td {
          position: relative;
          padding: 15px;
          &:first-child {
            border-right: 1px solid #e5e5e5;
            .max {
              color: #70acf6;
            }
          }
          &:last-child {
            .max {
              color: #ff5000;
            }
          }
          p {
            margin-bottom: 6px;
            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }

      .compare {
        z-index: 1;
        position: absolute;
        right: -15px;
        top: 50%;
        width: 30px;
        height: 30px;
        line-height: 26px;
        color: #fff;
        font-size: 20px;
        background-color: #70acf6;
        transform: translateY(-50%);
        border-radius: 100rem;
      }
      .empty-center {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
  .compare-list {
    overflow: hidden;
    font-size: 13px;
    li {
      position: relative;
      float: left;
      width: 100%;
      &:after {
        @apply --bd-h;
        left: 0;
        bottom: 0;
        background-color: #e5e5e5;
      }
      .cell {
        &:last-child {
          text-align: center;
          padding: 12px 3px;
        }
      }
    }
    .thead {
      background-color: #f8f8f8;
      .cell {
        @apply --text-ellipsis;
        &:after {
          content: none;
        }
      }
    }
    .cell {
      position: relative;
      float: left;
      width: 39%;
      padding: 12px;
      &:last-child {
        width: 22%;
        p {
          padding-right: 16px;
          text-align: right;
        }
      }
      &:after {
        @apply --bd-w;
        right: 0;
        top: 0;
        background-color: #e5e5e5;
      }
      p {
        @apply --text-ellipsis;
      }
      i {
        position: absolute;
        right: 6px;
        top: 13px;
        width: 12px;
        height: 12px;
        margin-left: 3px;
        color: #ccc;
      }
    }
  }
</style>